// extracted by mini-css-extract-plugin
export var arrow = "work-module--arrow--xi88D";
export var content = "work-module--content--10VU3";
export var header = "work-module--header--K4okX";
export var link = "work-module--link---qswS";
export var next = "work-module--next--tgy4K";
export var prev = "work-module--prev--f3WK6";
export var video = "work-module--video--ZK-QQ";
export var videoContainer = "work-module--video-container--ukTTS";
export var work = "work-module--work--mljte";